<template>
  <div>
    <el-container>
      <el-header width="500px" height="100px">
        <el-menu
          default-active="1"
          class="el-menu-demo"
          mode="horizontal">
          <el-menu-item index="1" @click="createHospital">
            <i class="el-icon-school"></i>
            <span slot="title">创建医院</span>
          </el-menu-item>
          <!-- <el-menu-item index="2" @click="addMember">
            <i class="el-icon-user"></i>
            <span slot="title">添加成员</span>
          </el-menu-item> -->
        </el-menu>
      </el-header>
      <el-main class="main">
        <router-view/>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "HospitalManage",
  mounted() {
    this.$router.push({'name': 'createHospital'})
  },
  methods: {
    createHospital() {
      this.$router.push({'name': 'createHospital'})
    },
    addMember() {
      this.$router.push({'name': 'addMember'})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HospitalManage.vue